import script from "./VendorDetail011.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorDetail011.vue?vue&type=script&setup=true&lang=js"

import "./VendorDetail011.vue?vue&type=style&index=0&id=7c6495bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c6495bc"]])

export default __exports__